/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-destructuring */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import lod_ from "lodash";
import { useEffect } from "react";
// react-table components
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import i18n from "i18n";
import { IconButton } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/Basics/MDBox";

// Material Dashboard 2 PRO React examples
import DataTableHeadCell from "./DataTableHeadCell";
import DataTableBodyCell from "./DataTableBodyCell";
import { t } from "i18next";
import { getLabel } from "helpers/dictionary";
import { useSelector } from "react-redux";

const FiltersCell = ({ cell, noEndBorder, rows, index, dictionary: dictionaries, language }) => {
	const filters = cell.value ?? [];

	const labels = [];

	for (let filter of filters) {
		if (filter.source === "special") {
			labels.push(t(`FILTERS.${filter.path}`));
		} else {
			let dictionary = lod_.get(dictionaries, filter.dictionary);
			if (!lod_.isNil(dictionary)) {
				let item = lod_.get(dictionary.items ?? {}, filter.path.replaceAll(".", ".items."));
				if (!lod_.isNil(item)) {
					let label = getLabel(item.label, language);
					labels.push(label);
				}
			}
		}
	}
	return (
		<DataTableBodyCell
			noBorder={noEndBorder && rows.length - 1 === index}
			align={cell.column.align ? cell.column.align : "left"}
			{...cell.getCellProps()}
			style={{}}
			subTitle={
				cell.column.id === "name"
					? "(" + i18n.t(`SETTINGS.PAGES.${cell.row.values.type}`) + ")"
					: null
			}
			override={cell.column.id === "icon" ? <Icon fontSize="medium">{cell.value}</Icon> : null}
		>
			{labels.join(", ")}
		</DataTableBodyCell>
	);
};

function PagesDataTable({
	draggable,
	dragHandler,
	table,
	noEndBorder,
	display,
	actions,
	dictionary = {}
}) {
	const user = useSelector(state => state.user);
	const columns = table.columns;
	const data = table.rows;

	const tableInstance = useTable(
		{ columns, data, initialState: { pageIndex: 0 } },
		useGlobalFilter,
		useSortBy,
		usePagination
	);

	const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows, setPageSize, page } =
		tableInstance;

	/**
	 * ##############################
	 * Handle specials actions in props
	 * -> allow to custom actions with row values
	 * e.g : disabe, click, loadingn style
	 * ##############################
	 */
	function overrideObjectProps(action, row) {
		// custom disabled method
		const checkDisabled = act => {
			if (act.props?.disabled) {
				return act.props.disabled;
			} else if (act.props?.customdisabled) {
				return act.props.customdisabled(row);
			} else {
				return false;
			}
		};
		// custom style
		const customStyle = act => {
			let style = act.props?.style ?? {};
			if (act.props?.customstyle) {
				style = act.props.customstyle(row, style);
			}
			return style;
		};

		const customLoading = act => {
			if (act.props?.loading) {
				let loadingObject = act.props.loading(row);
				if (loadingObject.loading) {
					return loadingObject.component;
				}
			}
			return act.props?.children;
		};

		action = {
			...action,
			props: {
				...action.props,
				onClick(e) {
					action.props?.handleclick ? action.props?.handleclick(row, e) : null;
				},
				disabled: checkDisabled(action),
				style: customStyle(action),
				children: customLoading(action),
				// Pass extra param to props rowvalues
				rowvalues: row.values
			}
		};

		if (action.props.children && lod_.isObject(action.props.children)) {
			action.props.children = overrideObjectProps(action.props.children, row);
		}

		return action;
	}

	useEffect(() => setPageSize(1000), []);

	return (
		<TableContainer sx={{ boxShadow: "none" }}>
			<DragDropContext
				onDragEnd={({ destination, source }) => {
					if (!source || !destination) return;
					dragHandler({ from: source.index, to: destination.index });
				}}
			>
				<Table {...getTableProps()}>
					<MDBox component="thead">
						{headerGroups.map((headerGroup, groupIndex) => (
							<TableRow {...headerGroup.getHeaderGroupProps()} key={groupIndex}>
								<DataTableHeadCell width={10} align="left" sorted={false}></DataTableHeadCell>
								<DataTableHeadCell width={20} align="right" sorted={false}>
									Actions
								</DataTableHeadCell>
								{headerGroup.headers.map((column, index) => {
									if (display.includes(column.id)) {
										return (
											<DataTableHeadCell key={index} width="auto" align="left" sorted={false}>
												{column.render("Header")}
											</DataTableHeadCell>
										);
									}
									return null;
								})}
							</TableRow>
						))}
					</MDBox>
					<Droppable droppableId="dnd-list" direction="vertical">
						{provided => (
							<TableBody
								{...getTableBodyProps()}
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								{page.map((row, key) => {
									prepareRow(row);
									return (
										<Draggable
											isDragDisabled={!draggable}
											key={row.id}
											index={key}
											draggableId={row.id}
										>
											{provided => (
												<TableRow
													{...row.getRowProps()}
													ref={provided.innerRef}
													{...provided.draggableProps}
													{...provided.dragHandleProps}
												>
													<DataTableBodyCell>
														<Icon fontSize="medium">apps</Icon>
													</DataTableBodyCell>
													{actions && (
														<DataTableBodyCell align="center">
															<MDBox display="flex" justifyContent="flex-end">
																{actions.map((action, index) => {
																	action = overrideObjectProps(action, row);
																	return <span key={index}>{action}</span>;
																})}
															</MDBox>
														</DataTableBodyCell>
													)}
													{row.cells.map((cell, index) => {
														if (display.includes(cell.column.id)) {
															if (cell.column.id === "filters") {
																return (
																	<FiltersCell
																		key={index}
																		dictionary={dictionary}
																		language={user.language}
																		cell={cell}
																		noEndBorder={noEndBorder}
																		rows={rows}
																		index={index}
																	/>
																);
															}

															let style = {};
															switch (cell.row.values.type) {
																case "title":
																	style.fontWeight = "bold";
																	style.textTransform = "uppercase";
																	break;
																case "divider":
																	break;
																case "route":
																	break;
																default:
																	break;
															}

															return (
																<DataTableBodyCell
																	key={index}
																	noBorder={noEndBorder && rows.length - 1 === key}
																	align={cell.column.align ? cell.column.align : "left"}
																	{...cell.getCellProps()}
																	style={style}
																	subTitle={
																		cell.column.id === "name"
																			? "(" + i18n.t(`SETTINGS.PAGES.${cell.row.values.type}`) + ")"
																			: null
																	}
																	override={
																		cell.column.id === "icon" ? (
																			<Icon fontSize="medium">{cell.value}</Icon>
																		) : null
																	}
																>
																	{cell.render("Cell")}
																</DataTableBodyCell>
															);
														}

														return null;
													})}
												</TableRow>
											)}
										</Draggable>
									);
								})}
								{provided.placeholder}
							</TableBody>
						)}
					</Droppable>
				</Table>
			</DragDropContext>
		</TableContainer>
	);
}
export default PagesDataTable;
